
export const slugify = (text: string): string => {
  return text
    // Normaliser les caractères Unicode (décompose les accents)
    .normalize('NFD')
    // Supprimer tous les diacritiques (accents) et caractères de contrôle/invisibles
    .replace(/[\u0300-\u036f]/g, '')
    // Supprimer les caractères invisibles Unicode (zero-width, BOM, etc.)
    .replace(/[\u200B-\u200D\uFEFF\u00AD\u200E\u200F\u202A-\u202E\u2060-\u2064]/g, '')
    .toLowerCase()
    // Ne garder que lettres, chiffres et espaces
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const createEventSlug = (title: string): string => {
  return slugify(title);
};

/**
 * Génère un slug unique avec l'ID pour éviter les conflits
 */
export const generateOfferSlug = (title: string, id: string): string => {
  const slug = slugify(title);
  const shortId = id.substring(0, 8);
  return `${slug}-${shortId}`;
};

/**
 * Extrait l'ID d'un slug d'offre
 */
export const extractIdFromSlug = (slug: string): string => {
  const parts = slug.split('-');
  return parts[parts.length - 1];
};
